import PageHeader from "../common/pageHeader/v2";
import FAQ from "../components/section/faq";

const FAQPage = () => {

  return (
    <>
      <PageHeader title="Faqs" subTitle="questions & answer" />
      <FAQ />
    </>
  );
};

export default FAQPage;
